import axios from 'axios';
import {config} from '../shared/app.config';
import store from '../store/store';

const RESOURCE_NAME = '/webadmin/cartedishes';
const RESOURCE_NAME_PUBLIC = '/webadmin/public/cartedishes';

export default {
  getAllByRestaurant (restaurant_id, language) {
    if (!language) language = store.getters.getCurrentLanguage;
    return axios.get(`${config.webApiBase + RESOURCE_NAME  }/restaurant/${  restaurant_id}`, {
      headers: {
        'X-localization': language
      }
    });
  },
  getAllByRestaurantPublic (restaurant_id, language) {
    if (!language) language = store.getters.getCurrentLanguagePublic;
    return axios.get(`${config.webApiBase + RESOURCE_NAME_PUBLIC  }_simple/restaurant/${  restaurant_id}`, {
      headers: {
        'X-localization': language
      }
    });
  },
  getOnePublic (id, slug, language) {
    if (!language) language = store.getters.getCurrentLanguagePublic;
    return axios.get(`${config.webApiBase + RESOURCE_NAME_PUBLIC  }/${  id  }/${  slug}`,{
      headers: {
        'X-localization': language
      }
    });
  },
  getOne (id, language) {
    if (!language) language = store.getters.getCurrentLanguage;
    return axios.get(`${config.webApiBase + RESOURCE_NAME  }/${  id}`, {
      headers: {
        'X-localization': language
      }
    });
  },
  create (carte, language) {
    if (!language) language = store.getters.getCurrentLanguage;
    const requestConfig = {
      headers: {
        'Content-Type': 'multipart/form-data',
        'X-localization': language
      }
    };

    return axios.post(config.webApiBase + RESOURCE_NAME, carte, requestConfig);
  },
  edit (id, carte, language) {
    if (!language) language = store.getters.getCurrentLanguage;
    const requestConfig = {
      headers: {
        'Content-Type': 'multipart/form-data',
        'X-localization': language
      }
    };
    carte.model = 'put';
    return axios.post(`${config.webApiBase + RESOURCE_NAME  }/${  id}`, carte, requestConfig);
  },
  delete (id) {
    return axios.delete(`${config.webApiBase + RESOURCE_NAME  }/${  id}`);
  },
  deleteGroup (idGroup) {
    return axios.delete(`${config.webApiBase + RESOURCE_NAME  }/delete_group/${  idGroup}`);
  },
  createGroup (idCarte, group, language) {
    if (!language) language = store.getters.getCurrentLanguage;
    return axios.put(`${config.webApiBase + RESOURCE_NAME  }/${  idCarte  }/create_group`, group, {
      headers: {
        'X-localization': language
      }
    });
  },
  editGroup (id, group, language) {
    if (!language) language = store.getters.getCurrentLanguage;
    return axios.post(`${config.webApiBase + RESOURCE_NAME  }/edit_group/${  id}`, group, {
      headers: {
        'X-localization': language
      }
    });
  },
  active (id) {
    return axios.put(`${config.webApiBase + RESOURCE_NAME  }/${  id  }/state`, { active: true });
  },
  deactive (id) {
    return axios.put(`${config.webApiBase + RESOURCE_NAME  }/${  id  }/state`, { active: false });
  },
}
